// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Header {
    color: #223263;
    font-size: 2vw;
    padding: 0% 5%;
    text-align: center;
    align-items: center; 
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
  
  #ods-logo, #ods-sotenibilidad {
    width: 20%;
    text-align: center;
  } 
  
  #ods-logo img, #ods-sotenibilidad img {
    width: 100%;
    height: auto;
  }

  #ods-titulo {
    flex: 1 1;
    text-align: center; 
    font-size: 1.8vw; 
  }

  @media (max-width: 850px) {
    .Header {
      padding: 2% 2%;
      font-size: 2.5vw; 
    }
  
    #ods-logo,
    #ods-sotenibilidad {
      width: 25%;  
    }
  
    #ods-titulo {
      font-size: 2.2vw; 
    }
  }
  
  @media (max-width: 600px) {
    .Header {
      font-size: 3.5vw;
      align-items: center; 
      padding: 3% 0%;
    }
  
    #ods-logo, 
    #ods-sotenibilidad {
      width: 30%; 
      margin-bottom: 10px; 
    }
  
    #ods-logo img, 
    #ods-sotenibilidad img {
      width: 100%;  
      height: auto;  
    }
  
    #ods-titulo {
      font-size: 3vw; 
      margin-top: 10px;  
    }
  }`, "",{"version":3,"sources":["webpack://./src/styles/Header.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,cAAc;IACd,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,8BAA8B;IAC9B,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,SAAO;IACP,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE;MACE,cAAc;MACd,gBAAgB;IAClB;;IAEA;;MAEE,UAAU;IACZ;;IAEA;MACE,gBAAgB;IAClB;EACF;;EAEA;IACE;MACE,gBAAgB;MAChB,mBAAmB;MACnB,cAAc;IAChB;;IAEA;;MAEE,UAAU;MACV,mBAAmB;IACrB;;IAEA;;MAEE,WAAW;MACX,YAAY;IACd;;IAEA;MACE,cAAc;MACd,gBAAgB;IAClB;EACF","sourcesContent":[".Header {\n    color: #223263;\n    font-size: 2vw;\n    padding: 0% 5%;\n    text-align: center;\n    align-items: center; \n    display: flex;\n    justify-content: space-between;\n    flex-wrap: wrap;\n  }\n  \n  #ods-logo, #ods-sotenibilidad {\n    width: 20%;\n    text-align: center;\n  } \n  \n  #ods-logo img, #ods-sotenibilidad img {\n    width: 100%;\n    height: auto;\n  }\n\n  #ods-titulo {\n    flex: 1;\n    text-align: center; \n    font-size: 1.8vw; \n  }\n\n  @media (max-width: 850px) {\n    .Header {\n      padding: 2% 2%;\n      font-size: 2.5vw; \n    }\n  \n    #ods-logo,\n    #ods-sotenibilidad {\n      width: 25%;  \n    }\n  \n    #ods-titulo {\n      font-size: 2.2vw; \n    }\n  }\n  \n  @media (max-width: 600px) {\n    .Header {\n      font-size: 3.5vw;\n      align-items: center; \n      padding: 3% 0%;\n    }\n  \n    #ods-logo, \n    #ods-sotenibilidad {\n      width: 30%; \n      margin-bottom: 10px; \n    }\n  \n    #ods-logo img, \n    #ods-sotenibilidad img {\n      width: 100%;  \n      height: auto;  \n    }\n  \n    #ods-titulo {\n      font-size: 3vw; \n      margin-top: 10px;  \n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
